/* PastéBCN — Announcement Bar
   Marquee horizontal continuo. La animación es 100% CSS (translateX 0 → -50%
   sobre un track con dos sets idénticos). El JS solo se ocupa de:
   - Pausar la animación cuando la pestaña no está activa.
   - Detectar si con un único mensaje el texto cabe en pantalla y, en ese
     caso, evitar el marquee (mostrarlo estático centrado).
   - Asegurar que los enlaces del set duplicado no son tab-stops.

   Hover, focus y prefers-reduced-motion se manejan por CSS. */

if (!customElements.get('pb-announcement-bar')) {
  class PbAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.pb-announcement-bar__viewport');
      this.firstSet = this.querySelector('.pb-announcement-bar__set');
      this.firstItem = this.firstSet ? this.firstSet.querySelector('.pb-announcement-bar__item') : null;
      this.itemCount = parseInt(this.dataset.itemCount, 10) || 0;

      this._onVisibility = this._onVisibility.bind(this);
      this._checkFit = this._checkFit.bind(this);

      this._neutralizeDuplicateSets();

      document.addEventListener('visibilitychange', this._onVisibility);
      this.classList.toggle('is-tab-hidden', document.hidden);

      if (this.itemCount === 1 && this.firstItem && this.viewport) {
        this._checkFit();
        if (typeof ResizeObserver !== 'undefined') {
          this._ro = new ResizeObserver(this._checkFit);
          this._ro.observe(this.viewport);
        } else {
          window.addEventListener('resize', this._checkFit);
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this._onVisibility);
      window.removeEventListener('resize', this._checkFit);
      if (this._ro) {
        this._ro.disconnect();
        this._ro = null;
      }
    }

    _neutralizeDuplicateSets() {
      const sets = this.querySelectorAll('.pb-announcement-bar__set');
      if (sets.length < 2) return;
      for (let i = 1; i < sets.length; i++) {
        sets[i].querySelectorAll('a').forEach((link) => {
          link.setAttribute('tabindex', '-1');
          link.setAttribute('aria-hidden', 'true');
        });
      }
    }

    _onVisibility() {
      this.classList.toggle('is-tab-hidden', document.hidden);
    }

    _checkFit() {
      if (!this.firstItem || !this.viewport) return;
      const itemWidth = this.firstItem.scrollWidth;
      const viewportWidth = this.viewport.clientWidth;
      this.classList.toggle('is-static', itemWidth <= viewportWidth);
    }
  }

  customElements.define('pb-announcement-bar', PbAnnouncementBar);
}
